export default __webpack_public_path__ + "static/media/39.1b1b5812.jpg";